<template>
  <v-row v-for="panel in props.panels" :key="panel.id" class="ma-0 mb-n6">
    <v-expansion-panels class="my-5" ref="expPanel" @update:model-value="marcarEstadoPanel(panel.id)">
      <v-expansion-panel class="rounded-panel mb-5" rounded="m" :bg-color="panel.color">
        <v-expansion-panel-title expand-icon="mdi-plus-circle-outline" collapse-icon="mdi-minus-circle-outline">
          <h3 class="fMontserrat" style="color: white">{{ panel.title }}</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text :style="{ 'background-color': panel.subColor }" class="rounded-panelText">
          <img v-if="panel.imageContent" :src="panel.imageContent" style="width: 100%" :transition="false" />
          <p class="fMontserrat font-weight-medium blackText" v-html="formatContent(panel.content)" />
          <v-row class="ma-0 text-center">
            <v-col v-for="image in panel.images" :key="image.id" :cols="image.cols" align-self="center">
              <img :src="image.src" :transition="false" :style="`width: 100%; ${image.maxwidth != null ? `max-width: ${image.maxwidth}` : ''}`" />
            </v-col>
            <v-col v-for="video in panel.videos" :key="video.id" :cols="video.cols" align-self="center">
              <video
                v-if="showVideos"
                controls
                autoplay
                :src="video.src"
                :transition="false"
                :style="`width: 100%; ${video.maxwidth != null ? `max-width: ${video.maxwidth}` : ''}`"
                type="video/mp4" />
            </v-col>
          </v-row>
          <p v-if="panel.content2" class="fMontserrat font-weight-medium blackText" v-html="formatContent(panel.content2)" />
          <RecursiveExpansionPanel :panels="panel.subPanels" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script setup>
import { ref, defineProps } from "vue";

const showVideos = ref(false);

const props = defineProps({ panels: Array });
const expPanel = ref(null);
const formatContent = (content) => {
  return content.replace(/\n/g, "<br>");
};
const marcarEstadoPanel = (panelId) => {
  var panel = props.panels.find((x) => x.id === panelId);
  panel.open = !panel.open;
};
</script>

<style>
.movedIcon {
  position: absolute;
  top: 0px;
  left: 0px;
}

.fMontserrat {
  font-family: Montserrat;
}

.rounded-panel {
  border-radius: 8px !important;
}

.rounded-panelText {
  border-radius: 0% 0% 8px 8px;
}
.blackText {
  color: black;
}
</style>
